import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths, splitProjectFullPath } from '~/lib/utils/path_helpers/utils';


/**
 * Generates rails route to
 * /:project_full_path/-/preview_markdown(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPreviewMarkdownPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPreviewMarkdownPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectPreviewMarkdownPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPreviewMarkdownPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPreviewMarkdownPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/archive/*id.:format
 * @param {string} projectFullPath
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectArchivePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectArchivePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"archive"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _namespaceProjectArchivePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"archive"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectArchivePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectArchivePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/sast(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationSastPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationSastPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"sast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationSastPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"sast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationSastPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationSastPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/artifacts(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/artifacts/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectArtifactPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectArtifactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectArtifactPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectArtifactPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectArtifactPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/packages(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPackagesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPackagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectPackagesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPackagesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPackagesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/packages/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPackagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPackagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectPackagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPackagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPackagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/package_files/:id/download(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadProjectPackageFilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadOrganizationNamespaceProjectPackageFilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"package_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _downloadNamespaceProjectPackageFilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"package_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _downloadOrganizationNamespaceProjectPackageFilePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _downloadNamespaceProjectPackageFilePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/terraform_module_registry(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectInfrastructureRegistryIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectInfrastructureRegistryIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform_module_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectInfrastructureRegistryIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform_module_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectInfrastructureRegistryIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectInfrastructureRegistryIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/terraform_module_registry/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectInfrastructureRegistryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectInfrastructureRegistryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform_module_registry"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectInfrastructureRegistryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform_module_registry"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectInfrastructureRegistryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectInfrastructureRegistryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/artifacts/*ref_name_and_path
 * @param {string} projectFullPath
 * @param {any} refNameAndPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const latestSucceededProjectArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _latestSucceededOrganizationNamespaceProjectArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"ref_name_and_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[5,[3,"ref_name_and_path"]]]]]]]]]]]]]]]]]);
  const _latestSucceededNamespaceProjectArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"ref_name_and_path":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[5,[3,"ref_name_and_path"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _latestSucceededOrganizationNamespaceProjectArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _latestSucceededNamespaceProjectArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/status(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _statusOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _statusNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _statusOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _statusNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/cancel(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cancelOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cancelNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _cancelOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _cancelNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/unschedule(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unscheduleProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _unscheduleOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _unscheduleNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _unscheduleOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _unscheduleNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/retry(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _retryOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _retryNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _retryNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/play(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _playOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"play"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _playNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"play"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _playOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _playNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/erase(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eraseProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _eraseOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"erase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _eraseNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"erase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _eraseOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _eraseNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/trace(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traceProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _traceOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _traceNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _traceOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _traceNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/raw(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rawProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _rawOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"raw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _rawNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"raw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _rawOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _rawNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/viewer(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewerProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _viewerOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"viewer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _viewerNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"viewer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _viewerOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _viewerNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/terminal(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _terminalOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terminal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _terminalNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terminal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _terminalOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _terminalNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/proxy(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proxyProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _proxyOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proxy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _proxyNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proxy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _proxyOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _proxyNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id/test_report_summary(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testReportSummaryProjectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _testReportSummaryOrganizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_report_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _testReportSummaryNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_report_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _testReportSummaryOrganizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _testReportSummaryNamespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:job_id/artifacts/download(.:format)
 * @param {string} projectFullPath
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadProjectJobArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadOrganizationNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _downloadNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _downloadOrganizationNamespaceProjectJobArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _downloadNamespaceProjectJobArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:job_id/artifacts/browse(/*path)
 * @param {string} projectFullPath
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browseProjectJobArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _browseOrganizationNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"browse"],[1,[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]]]]]]);
  const _browseNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"browse"],[1,[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _browseOrganizationNamespaceProjectJobArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _browseNamespaceProjectJobArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:job_id/artifacts/file/*path
 * @param {string} projectFullPath
 * @param {any} jobId
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fileProjectJobArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _fileOrganizationNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]]]]]);
  const _fileNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _fileOrganizationNamespaceProjectJobArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _fileNamespaceProjectJobArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:job_id/artifacts/external_file/*path
 * @param {string} projectFullPath
 * @param {any} jobId
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalFileProjectJobArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _externalFileOrganizationNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"external_file"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]]]]]);
  const _externalFileNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"external_file"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _externalFileOrganizationNamespaceProjectJobArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _externalFileNamespaceProjectJobArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:job_id/artifacts/raw/*path
 * @param {string} projectFullPath
 * @param {any} jobId
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rawProjectJobArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _rawOrganizationNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"raw"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]]]]]);
  const _rawNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"raw"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _rawOrganizationNamespaceProjectJobArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _rawNamespaceProjectJobArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:job_id/artifacts/keep(.:format)
 * @param {string} projectFullPath
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const keepProjectJobArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _keepOrganizationNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"keep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _keepNamespaceProjectJobArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[6,"keep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _keepOrganizationNamespaceProjectJobArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _keepNamespaceProjectJobArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectJobsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectJobsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectJobsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectJobsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectJobsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/jobs/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectJobPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectJobPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectJobPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectJobPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ci/lint(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCiLintPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCiLintPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"lint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCiLintPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"lint"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCiLintPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCiLintPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ci/editor(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCiPipelineEditorPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCiPipelineEditorPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCiPipelineEditorPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCiPipelineEditorPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCiPipelineEditorPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ci/daily_build_group_report_results(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCiDailyBuildGroupReportResultsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCiDailyBuildGroupReportResultsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"daily_build_group_report_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCiDailyBuildGroupReportResultsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"daily_build_group_report_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCiDailyBuildGroupReportResultsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCiDailyBuildGroupReportResultsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ci/prometheus_metrics/histograms(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCiPrometheusMetricsHistogramsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCiPrometheusMetricsHistogramsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"prometheus_metrics"],[2,[7,"/"],[2,[6,"histograms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCiPrometheusMetricsHistogramsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ci"],[2,[7,"/"],[2,[6,"prometheus_metrics"],[2,[7,"/"],[2,[6,"histograms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCiPrometheusMetricsHistogramsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCiPrometheusMetricsHistogramsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/:id/register(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registerProjectRunnerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _registerOrganizationNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _registerNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _registerOrganizationNamespaceProjectRunnerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _registerNamespaceProjectRunnerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/:id/resume(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeProjectRunnerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resumeOrganizationNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resumeNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resumeOrganizationNamespaceProjectRunnerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resumeNamespaceProjectRunnerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/:id/pause(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseProjectRunnerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _pauseOrganizationNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _pauseNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _pauseOrganizationNamespaceProjectRunnerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _pauseNamespaceProjectRunnerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/toggle_shared_runners(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleSharedRunnersProjectRunnersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleSharedRunnersOrganizationNamespaceProjectRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"toggle_shared_runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _toggleSharedRunnersNamespaceProjectRunnersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"toggle_shared_runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleSharedRunnersOrganizationNamespaceProjectRunnersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleSharedRunnersNamespaceProjectRunnersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/toggle_group_runners(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleGroupRunnersProjectRunnersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleGroupRunnersOrganizationNamespaceProjectRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"toggle_group_runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _toggleGroupRunnersNamespaceProjectRunnersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"toggle_group_runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleGroupRunnersOrganizationNamespaceProjectRunnersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleGroupRunnersNamespaceProjectRunnersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRunnersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectRunnersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRunnersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRunnersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectRunnerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectRunnerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectRunnerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectRunnerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectRunnerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectRunnerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/runners/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRunnerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectRunnerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRunnerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRunnerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/ci_cd/reset_cache(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetCacheProjectSettingsCiCdPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resetCacheOrganizationNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"reset_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resetCacheNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"reset_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resetCacheOrganizationNamespaceProjectSettingsCiCdPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resetCacheNamespaceProjectSettingsCiCdPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/ci_cd/reset_registration_token(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetRegistrationTokenProjectSettingsCiCdPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resetRegistrationTokenOrganizationNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"reset_registration_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resetRegistrationTokenNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"reset_registration_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resetRegistrationTokenOrganizationNamespaceProjectSettingsCiCdPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resetRegistrationTokenNamespaceProjectSettingsCiCdPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/ci_cd/deploy_token/create(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeployTokenProjectSettingsCiCdPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _createDeployTokenOrganizationNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _createDeployTokenNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _createDeployTokenOrganizationNamespaceProjectSettingsCiCdPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _createDeployTokenNamespaceProjectSettingsCiCdPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/ci_cd/runner_setup_scripts(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runnerSetupScriptsProjectSettingsCiCdPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _runnerSetupScriptsOrganizationNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"runner_setup_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _runnerSetupScriptsNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"runner_setup_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _runnerSetupScriptsOrganizationNamespaceProjectSettingsCiCdPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _runnerSetupScriptsNamespaceProjectSettingsCiCdPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/ci_cd/export_job_token_authorizations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportJobTokenAuthorizationsProjectSettingsCiCdPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _exportJobTokenAuthorizationsOrganizationNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"export_job_token_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _exportJobTokenAuthorizationsNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"export_job_token_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _exportJobTokenAuthorizationsOrganizationNamespaceProjectSettingsCiCdPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _exportJobTokenAuthorizationsNamespaceProjectSettingsCiCdPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/ci_cd(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsCiCdPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsCiCdPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsCiCdPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/operations/reset_pagerduty_token(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPagerdutyTokenProjectSettingsOperationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resetPagerdutyTokenOrganizationNamespaceProjectSettingsOperationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operations"],[2,[7,"/"],[2,[6,"reset_pagerduty_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resetPagerdutyTokenNamespaceProjectSettingsOperationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operations"],[2,[7,"/"],[2,[6,"reset_pagerduty_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resetPagerdutyTokenOrganizationNamespaceProjectSettingsOperationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resetPagerdutyTokenNamespaceProjectSettingsOperationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/operations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsOperationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsOperationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsOperationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsOperationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsOperationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/integrations/:id/test(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testProjectSettingsIntegrationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _testOrganizationNamespaceProjectSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _testNamespaceProjectSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _testOrganizationNamespaceProjectSettingsIntegrationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _testNamespaceProjectSettingsIntegrationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/integrations/:integration_id/hook_logs/:id/retry(.:format)
 * @param {string} projectFullPath
 * @param {any} integrationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryProjectSettingsIntegrationHookLogPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _retryOrganizationNamespaceProjectSettingsIntegrationHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"integration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _retryNamespaceProjectSettingsIntegrationHookLogPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"integration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationNamespaceProjectSettingsIntegrationHookLogPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _retryNamespaceProjectSettingsIntegrationHookLogPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/integrations/:integration_id/hook_logs/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} integrationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsIntegrationHookLogPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsIntegrationHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"integration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsIntegrationHookLogPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"integration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsIntegrationHookLogPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsIntegrationHookLogPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/integrations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsIntegrationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsIntegrationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsIntegrationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsIntegrationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsIntegrationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/integrations/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectSettingsIntegrationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectSettingsIntegrationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectSettingsIntegrationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/integrations/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsIntegrationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsIntegrationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsIntegrationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/slack/slack_auth(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackAuthProjectSettingsSlackPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _slackAuthOrganizationNamespaceProjectSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _slackAuthNamespaceProjectSettingsSlackPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _slackAuthOrganizationNamespaceProjectSettingsSlackPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _slackAuthNamespaceProjectSettingsSlackPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/slack/edit(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectSettingsSlackPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSettingsSlackPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectSettingsSlackPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectSettingsSlackPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/slack(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsSlackPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsSlackPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsSlackPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsSlackPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/repository/deploy_token/create(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeployTokenProjectSettingsRepositoryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _createDeployTokenOrganizationNamespaceProjectSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _createDeployTokenNamespaceProjectSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _createDeployTokenOrganizationNamespaceProjectSettingsRepositoryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _createDeployTokenNamespaceProjectSettingsRepositoryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/repository/cleanup(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanupProjectSettingsRepositoryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cleanupOrganizationNamespaceProjectSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cleanupNamespaceProjectSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _cleanupOrganizationNamespaceProjectSettingsRepositoryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _cleanupNamespaceProjectSettingsRepositoryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/repository/branch_rules(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsRepositoryBranchRulesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsRepositoryBranchRulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"branch_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsRepositoryBranchRulesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"branch_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsRepositoryBranchRulesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsRepositoryBranchRulesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/repository(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsRepositoryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsRepositoryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsRepositoryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/access_tokens/:id/revoke(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeProjectSettingsAccessTokenPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _revokeOrganizationNamespaceProjectSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _revokeNamespaceProjectSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _revokeOrganizationNamespaceProjectSettingsAccessTokenPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _revokeNamespaceProjectSettingsAccessTokenPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/access_tokens/:id/rotate(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotateProjectSettingsAccessTokenPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _rotateOrganizationNamespaceProjectSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _rotateNamespaceProjectSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _rotateOrganizationNamespaceProjectSettingsAccessTokenPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _rotateNamespaceProjectSettingsAccessTokenPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/access_tokens/inactive(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveProjectSettingsAccessTokensPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _inactiveOrganizationNamespaceProjectSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _inactiveNamespaceProjectSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationNamespaceProjectSettingsAccessTokensPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _inactiveNamespaceProjectSettingsAccessTokensPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/access_tokens(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsAccessTokensPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsAccessTokensPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsAccessTokensPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/packages_and_registries/cleanup_image_tags(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanupImageTagsProjectSettingsPackagesAndRegistriesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cleanupImageTagsOrganizationNamespaceProjectSettingsPackagesAndRegistriesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[2,[7,"/"],[2,[6,"cleanup_image_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cleanupImageTagsNamespaceProjectSettingsPackagesAndRegistriesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[2,[7,"/"],[2,[6,"cleanup_image_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _cleanupImageTagsOrganizationNamespaceProjectSettingsPackagesAndRegistriesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _cleanupImageTagsNamespaceProjectSettingsPackagesAndRegistriesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/packages_and_registries(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsPackagesAndRegistriesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsPackagesAndRegistriesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsPackagesAndRegistriesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsPackagesAndRegistriesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsPackagesAndRegistriesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/merge_requests(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsMergeRequestsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsMergeRequestsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsMergeRequestsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsMergeRequestsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/usage_quotas(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectUsageQuotasPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectUsageQuotasPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectUsageQuotasPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"usage_quotas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectUsageQuotasPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectUsageQuotasPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/members(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membersProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _membersOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _membersNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _membersOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _membersNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/issues(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _issuesOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _issuesNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _issuesOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _issuesNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/merge_requests(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _mergeRequestsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _mergeRequestsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _mergeRequestsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/labels(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labelsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _labelsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _labelsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _labelsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _labelsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/milestones(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestonesProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _milestonesOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _milestonesNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _milestonesOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _milestonesNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/commands(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commandsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _commandsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"commands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _commandsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"commands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _commandsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _commandsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/snippets(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snippetsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _snippetsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _snippetsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _snippetsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _snippetsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/contacts(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _contactsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _contactsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _contactsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _contactsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/wikis(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wikisProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _wikisOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"wikis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _wikisNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"wikis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _wikisOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _wikisNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/project_members/leave(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leaveProjectProjectMembersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _leaveOrganizationNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _leaveNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _leaveOrganizationNamespaceProjectProjectMembersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _leaveNamespaceProjectProjectMembersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/project_members/invite_search(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inviteSearchProjectProjectMembersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _inviteSearchOrganizationNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[6,"invite_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _inviteSearchNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[6,"invite_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _inviteSearchOrganizationNamespaceProjectProjectMembersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _inviteSearchNamespaceProjectProjectMembersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/project_members/:id/resend_invite(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendInviteProjectProjectMemberPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resendInviteOrganizationNamespaceProjectProjectMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resendInviteNamespaceProjectProjectMemberPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resendInviteOrganizationNamespaceProjectProjectMemberPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resendInviteNamespaceProjectProjectMemberPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/project_members(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectProjectMembersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectProjectMembersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectProjectMembersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/project_members/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectProjectMemberPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectProjectMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectProjectMemberPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectProjectMemberPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectProjectMemberPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/enabled_keys(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enabledKeysProjectDeployKeysPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _enabledKeysOrganizationNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"enabled_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _enabledKeysNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"enabled_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _enabledKeysOrganizationNamespaceProjectDeployKeysPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _enabledKeysNamespaceProjectDeployKeysPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/available_project_keys(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availableProjectKeysProjectDeployKeysPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _availableProjectKeysOrganizationNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"available_project_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _availableProjectKeysNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"available_project_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _availableProjectKeysOrganizationNamespaceProjectDeployKeysPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _availableProjectKeysNamespaceProjectDeployKeysPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/available_public_keys(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availablePublicKeysProjectDeployKeysPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _availablePublicKeysOrganizationNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"available_public_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _availablePublicKeysNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"available_public_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _availablePublicKeysOrganizationNamespaceProjectDeployKeysPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _availablePublicKeysNamespaceProjectDeployKeysPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/:id/enable(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableProjectDeployKeyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _enableOrganizationNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _enableNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _enableOrganizationNamespaceProjectDeployKeyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _enableNamespaceProjectDeployKeyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/:id/disable(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableProjectDeployKeyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _disableOrganizationNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _disableNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _disableOrganizationNamespaceProjectDeployKeyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _disableNamespaceProjectDeployKeyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDeployKeysPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectDeployKeysPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDeployKeysPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDeployKeysPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectDeployKeyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectDeployKeyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectDeployKeyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectDeployKeyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectDeployKeyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectDeployKeyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_keys/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDeployKeyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectDeployKeyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDeployKeyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDeployKeyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/deploy_tokens/:id/revoke(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeProjectDeployTokenPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _revokeOrganizationNamespaceProjectDeployTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _revokeNamespaceProjectDeployTokenPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _revokeOrganizationNamespaceProjectDeployTokenPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _revokeNamespaceProjectDeployTokenPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id/promote(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promoteProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _promoteOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _promoteNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _promoteOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _promoteNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id/issues(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _issuesOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _issuesNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _issuesOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _issuesNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id/merge_requests(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _mergeRequestsOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _mergeRequestsNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _mergeRequestsNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id/participants(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participantsProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _participantsOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _participantsNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _participantsOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _participantsNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id/labels(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labelsProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _labelsOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _labelsNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _labelsOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _labelsNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMilestonesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMilestonesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMilestonesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMilestonesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMilestonesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/milestones/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMilestonePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMilestonePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMilestonePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMilestonePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/generate(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateProjectLabelsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _generateOrganizationNamespaceProjectLabelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _generateNamespaceProjectLabelsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _generateOrganizationNamespaceProjectLabelsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _generateNamespaceProjectLabelsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/set_priorities(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setPrioritiesProjectLabelsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _setPrioritiesOrganizationNamespaceProjectLabelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"set_priorities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _setPrioritiesNamespaceProjectLabelsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"set_priorities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _setPrioritiesOrganizationNamespaceProjectLabelsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _setPrioritiesNamespaceProjectLabelsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/:id/promote(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promoteProjectLabelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _promoteOrganizationNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _promoteNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _promoteOrganizationNamespaceProjectLabelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _promoteNamespaceProjectLabelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/:id/toggle_subscription(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleSubscriptionProjectLabelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleSubscriptionOrganizationNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleSubscriptionNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleSubscriptionOrganizationNamespaceProjectLabelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleSubscriptionNamespaceProjectLabelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/:id/remove_priority(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removePriorityProjectLabelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _removePriorityOrganizationNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _removePriorityNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _removePriorityOrganizationNamespaceProjectLabelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _removePriorityNamespaceProjectLabelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectLabelsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLabelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectLabelsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectLabelsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectLabelsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectLabelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectLabelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectLabelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectLabelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectLabelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectLabelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/labels/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectLabelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectLabelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectLabelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectLabelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/boards(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectBoardsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectBoardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectBoardsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectBoardsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectBoardsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/boards/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectBoardPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectBoardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectBoardPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectBoardPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectBoardPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/releases/permalink/latest(/)(*suffix_path)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectLatestReleasePermalinkPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLatestReleasePermalinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"suffix_path":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[6,"permalink"],[2,[7,"/"],[2,[6,"latest"],[2,[1,[7,"/"]],[1,[5,[3,"suffix_path"]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectLatestReleasePermalinkPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"suffix_path":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[6,"permalink"],[2,[7,"/"],[2,[6,"latest"],[2,[1,[7,"/"]],[1,[5,[3,"suffix_path"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectLatestReleasePermalinkPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectLatestReleasePermalinkPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/releases/:tag/downloads/*filepath
 * @param {string} projectFullPath
 * @param {any} tag
 * @param {any} filepath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadsProjectReleasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadsOrganizationNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"filepath":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[2,[7,"/"],[2,[6,"downloads"],[2,[7,"/"],[5,[3,"filepath"]]]]]]]]]]]]]]]]]]]);
  const _downloadsNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"filepath":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[2,[7,"/"],[2,[6,"downloads"],[2,[7,"/"],[5,[3,"filepath"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _downloadsOrganizationNamespaceProjectReleasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _downloadsNamespaceProjectReleasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/releases/:tag/evidences/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} tag
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectEvidencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectEvidencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[2,[7,"/"],[2,[6,"evidences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectEvidencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[2,[7,"/"],[2,[6,"evidences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectEvidencePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectEvidencePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/releases/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectReleasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectReleasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectReleasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/releases/:tag/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} tag
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectReleasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectReleasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectReleasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/releases/:tag(.:format)
 * @param {string} projectFullPath
 * @param {any} tag
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectReleasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectReleasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"tag":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[2,[7,"/"],[2,[3,"tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectReleasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectReleasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/starrers(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectStarrersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectStarrersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"starrers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectStarrersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"starrers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectStarrersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectStarrersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/forks(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectForksPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectForksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"forks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectForksPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"forks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectForksPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectForksPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/forks/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectForkPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectForkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"forks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectForkPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"forks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectForkPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectForkPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/group_links/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGroupLinkPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGroupLinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGroupLinkPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGroupLinkPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGroupLinkPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/import/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectImportPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectImportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectImportPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectImportPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectImportPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/import(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectImportPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectImportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectImportPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectImportPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectImportPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/avatar(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAvatarPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAvatarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAvatarPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAvatarPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAvatarPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/mattermost/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectMattermostPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectMattermostPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mattermost"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectMattermostPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mattermost"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectMattermostPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectMattermostPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/mattermost(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMattermostPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMattermostPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mattermost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMattermostPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mattermost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMattermostPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMattermostPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/variables(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectVariablesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVariablesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"variables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectVariablesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"variables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectVariablesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectVariablesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/triggers(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTriggersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTriggersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"triggers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTriggersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"triggers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTriggersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTriggersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/triggers/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTriggerPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTriggerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"triggers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTriggerPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"triggers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTriggerPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTriggerPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/mirror/ssh_host_keys(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sshHostKeysProjectMirrorPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _sshHostKeysOrganizationNamespaceProjectMirrorPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mirror"],[2,[7,"/"],[2,[6,"ssh_host_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _sshHostKeysNamespaceProjectMirrorPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mirror"],[2,[7,"/"],[2,[6,"ssh_host_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _sshHostKeysOrganizationNamespaceProjectMirrorPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _sshHostKeysNamespaceProjectMirrorPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/mirror/update_now(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateNowProjectMirrorPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _updateNowOrganizationNamespaceProjectMirrorPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mirror"],[2,[7,"/"],[2,[6,"update_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _updateNowNamespaceProjectMirrorPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mirror"],[2,[7,"/"],[2,[6,"update_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _updateNowOrganizationNamespaceProjectMirrorPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _updateNowNamespaceProjectMirrorPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/mirror(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMirrorPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMirrorPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mirror"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMirrorPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mirror"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMirrorPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMirrorPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/issue(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"issue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"issue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsIssuePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsIssuePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/plan(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsPlanPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsPlanPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsPlanPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsPlanPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsPlanPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/code(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsCodePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsCodePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsCodePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsCodePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsCodePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/test(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsTestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsTestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsTestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsTestPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsTestPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/review(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsReviewPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsReviewPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsReviewPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsReviewPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsReviewPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/staging(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsStagingPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsStagingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"staging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsStagingPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"staging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsStagingPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsStagingPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/value_stream_analytics/events/production(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCycleAnalyticsProductionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCycleAnalyticsProductionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"production"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCycleAnalyticsProductionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"production"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCycleAnalyticsProductionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCycleAnalyticsProductionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/median(.:format)
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const medianProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _medianOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"median"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _medianNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"median"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _medianOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _medianNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average(.:format)
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const averageProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _averageOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _averageNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _averageOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _averageNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/records(.:format)
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordsProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _recordsOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _recordsNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _recordsOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _recordsNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/count(.:format)
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const countProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _countOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _countNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _countOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _countNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages(.:format)
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsValueStreamStagesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamStagesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsValueStreamStagesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsValueStreamsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/summary(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsSummaryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsSummaryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsSummaryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cluster_agents/:name(.:format)
 * @param {string} projectFullPath
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectClusterAgentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectClusterAgentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cluster_agents"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectClusterAgentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cluster_agents"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectClusterAgentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectClusterAgentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/terraform(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTerraformIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTerraformIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTerraformIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTerraformIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTerraformIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/configuration(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudConfigurationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudConfigurationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudConfigurationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudConfigurationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudConfigurationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/revoke_oauth(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudRevokeOauthIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudRevokeOauthIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"revoke_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudRevokeOauthIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"revoke_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudRevokeOauthIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudRevokeOauthIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/service_accounts(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudServiceAccountsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudServiceAccountsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"service_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudServiceAccountsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"service_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudServiceAccountsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudServiceAccountsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/gcp_regions(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudGcpRegionsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudGcpRegionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"gcp_regions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudGcpRegionsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"gcp_regions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudGcpRegionsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudGcpRegionsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/deployments(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudDeploymentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudDeploymentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"deployments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudDeploymentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"deployments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudDeploymentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudDeploymentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/deployments/cloud_run(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudDeploymentsCloudRunPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudDeploymentsCloudRunPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"deployments"],[2,[7,"/"],[2,[6,"cloud_run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudDeploymentsCloudRunPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"deployments"],[2,[7,"/"],[2,[6,"cloud_run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudDeploymentsCloudRunPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudDeploymentsCloudRunPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/deployments/cloud_storage(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudDeploymentsCloudStoragePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudDeploymentsCloudStoragePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"deployments"],[2,[7,"/"],[2,[6,"cloud_storage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudDeploymentsCloudStoragePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"deployments"],[2,[7,"/"],[2,[6,"cloud_storage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudDeploymentsCloudStoragePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudDeploymentsCloudStoragePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/databases(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGoogleCloudDatabasesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGoogleCloudDatabasesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"databases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectGoogleCloudDatabasesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"databases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGoogleCloudDatabasesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGoogleCloudDatabasesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/google_cloud/databases/new/:product(.:format)
 * @param {string} projectFullPath
 * @param {any} product
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectGoogleCloudDatabasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectGoogleCloudDatabasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"product":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"databases"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectGoogleCloudDatabasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"product":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"google_cloud"],[2,[7,"/"],[2,[6,"databases"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectGoogleCloudDatabasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectGoogleCloudDatabasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/aws(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAwsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAwsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"aws"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAwsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"aws"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAwsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAwsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/aws/configuration(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAwsConfigurationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAwsConfigurationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"aws"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAwsConfigurationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"aws"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAwsConfigurationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAwsConfigurationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id/stop(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stopProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _stopOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _stopNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _stopOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _stopNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id/cancel_auto_stop(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelAutoStopProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cancelAutoStopOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_auto_stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cancelAutoStopNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_auto_stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _cancelAutoStopOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _cancelAutoStopNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id/terminal(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminalProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _terminalOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terminal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _terminalNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terminal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _terminalOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _terminalNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id/k8s(/*vueroute)(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const k8sSubrouteProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _k8sSubrouteOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"k8s"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _k8sSubrouteNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"k8s"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _k8sSubrouteOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _k8sSubrouteNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id/prometheus/api/v1/*proxy_path(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {any} proxyPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prometheusApiProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _prometheusApiOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"proxy_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"prometheus"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[5,[3,"proxy_path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _prometheusApiNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"proxy_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"prometheus"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[5,[3,"proxy_path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _prometheusApiOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _prometheusApiNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/folders/*id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const folderProjectEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _folderOrganizationNamespaceProjectEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _folderNamespaceProjectEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _folderOrganizationNamespaceProjectEnvironmentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _folderNamespaceProjectEnvironmentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/search(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchProjectEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _searchOrganizationNamespaceProjectEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _searchNamespaceProjectEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _searchOrganizationNamespaceProjectEnvironmentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _searchNamespaceProjectEnvironmentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:environment_id/deployments(.:format)
 * @param {string} projectFullPath
 * @param {any} environmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectEnvironmentDeploymentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectEnvironmentDeploymentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"environment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"deployments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectEnvironmentDeploymentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"environment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"deployments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectEnvironmentDeploymentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectEnvironmentDeploymentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:environment_id/deployments/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} environmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectEnvironmentDeploymentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectEnvironmentDeploymentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"environment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"deployments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectEnvironmentDeploymentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"environment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"deployments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectEnvironmentDeploymentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectEnvironmentDeploymentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectEnvironmentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectEnvironmentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/environments/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/alert_management/:id/details(/*page)(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsProjectAlertManagementPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _detailsOrganizationNamespaceProjectAlertManagementPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"page":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"alert_management"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[2,[1,[2,[7,"/"],[5,[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _detailsNamespaceProjectAlertManagementPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"page":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"alert_management"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[2,[1,[2,[7,"/"],[5,[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _detailsOrganizationNamespaceProjectAlertManagementPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _detailsNamespaceProjectAlertManagementPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/alert_management(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAlertManagementIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAlertManagementIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"alert_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAlertManagementIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"alert_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAlertManagementIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAlertManagementIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/alert_management/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAlertManagementAlertPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAlertManagementAlertPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"alert_management"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAlertManagementAlertPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"alert_management"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAlertManagementAlertPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAlertManagementAlertPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectWorkItemsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectWorkItemsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectWorkItemsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectWorkItemsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/views/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSavedViewPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSavedViewPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSavedViewPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSavedViewPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSavedViewPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/import_csv(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvProjectWorkItemsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _importCsvOrganizationNamespaceProjectWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _importCsvNamespaceProjectWorkItemsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _importCsvOrganizationNamespaceProjectWorkItemsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _importCsvNamespaceProjectWorkItemsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/import_csv/authorize(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvAuthorizeProjectWorkItemsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _importCsvAuthorizeOrganizationNamespaceProjectWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"import_csv"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _importCsvAuthorizeNamespaceProjectWorkItemsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"import_csv"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _importCsvAuthorizeOrganizationNamespaceProjectWorkItemsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _importCsvAuthorizeNamespaceProjectWorkItemsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/:iid/designs(/*vueroute)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const designsProjectWorkItemPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _designsOrganizationNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"designs"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]]]);
  const _designsNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"designs"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _designsOrganizationNamespaceProjectWorkItemPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _designsNamespaceProjectWorkItemPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectWorkItemPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectWorkItemPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectWorkItemPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/:iid/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectWorkItemPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectWorkItemPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectWorkItemPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/work_items/:iid(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectWorkItemPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectWorkItemPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectWorkItemPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectWorkItemPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/incidents/integrations/pagerduty(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIncidentsIntegrationsPagerdutyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIncidentsIntegrationsPagerdutyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pagerduty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIncidentsIntegrationsPagerdutyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pagerduty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIncidentsIntegrationsPagerdutyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIncidentsIntegrationsPagerdutyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/incidents(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIncidentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIncidentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIncidentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIncidentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIncidentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/incident_management/timeline_events/preview_markdown(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewMarkdownProjectIncidentManagementTimelineEventsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _previewMarkdownOrganizationNamespaceProjectIncidentManagementTimelineEventsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"incident_management"],[2,[7,"/"],[2,[6,"timeline_events"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _previewMarkdownNamespaceProjectIncidentManagementTimelineEventsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"incident_management"],[2,[7,"/"],[2,[6,"timeline_events"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _previewMarkdownOrganizationNamespaceProjectIncidentManagementTimelineEventsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _previewMarkdownNamespaceProjectIncidentManagementTimelineEventsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/error_tracking/projects(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectErrorTrackingProjectsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectErrorTrackingProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectErrorTrackingProjectsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectErrorTrackingProjectsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectErrorTrackingProjectsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/error_tracking/:issue_id/details(.:format)
 * @param {string} projectFullPath
 * @param {any} issueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsProjectErrorTrackingIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _detailsOrganizationNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"issue_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[3,"issue_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _detailsNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"issue_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[3,"issue_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _detailsOrganizationNamespaceProjectErrorTrackingIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _detailsNamespaceProjectErrorTrackingIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/error_tracking/:issue_id/stack_trace(.:format)
 * @param {string} projectFullPath
 * @param {any} issueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stackTraceProjectErrorTrackingIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _stackTraceOrganizationNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"issue_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[3,"issue_id"],[2,[7,"/"],[2,[6,"stack_trace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _stackTraceNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"issue_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[3,"issue_id"],[2,[7,"/"],[2,[6,"stack_trace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _stackTraceOrganizationNamespaceProjectErrorTrackingIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _stackTraceNamespaceProjectErrorTrackingIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/error_tracking/:issue_id(.:format)
 * @param {string} projectFullPath
 * @param {any} issueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateProjectErrorTrackingIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _updateOrganizationNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"issue_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[3,"issue_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _updateNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"issue_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[2,[7,"/"],[2,[3,"issue_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _updateOrganizationNamespaceProjectErrorTrackingIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _updateNamespaceProjectErrorTrackingIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/error_tracking(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectErrorTrackingIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectErrorTrackingIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"error_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectErrorTrackingIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectErrorTrackingIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/design_management/designs/:design_id(/:sha)/raw_image(.:format)
 * @param {string} projectFullPath
 * @param {any} designId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDesignManagementDesignsRawImagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDesignManagementDesignsRawImagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"design_id":{"r":true},"sha":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"design_management"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[3,"design_id"],[2,[1,[2,[7,"/"],[3,"sha"]]],[2,[7,"/"],[2,[6,"raw_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectDesignManagementDesignsRawImagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"design_id":{"r":true},"sha":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"design_management"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[3,"design_id"],[2,[1,[2,[7,"/"],[3,"sha"]]],[2,[7,"/"],[2,[6,"raw_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDesignManagementDesignsRawImagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDesignManagementDesignsRawImagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/design_management/designs/:design_id(/:sha)/resized_image/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} designId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDesignManagementDesignsResizedImagePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDesignManagementDesignsResizedImagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"design_id":{"r":true},"sha":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"design_management"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[3,"design_id"],[2,[1,[2,[7,"/"],[3,"sha"]]],[2,[7,"/"],[2,[6,"resized_image"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectDesignManagementDesignsResizedImagePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"design_id":{"r":true},"sha":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"design_management"],[2,[7,"/"],[2,[6,"designs"],[2,[7,"/"],[2,[3,"design_id"],[2,[1,[2,[7,"/"],[3,"sha"]]],[2,[7,"/"],[2,[6,"resized_image"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDesignManagementDesignsResizedImagePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDesignManagementDesignsResizedImagePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets/:snippet_id/raw/:ref/*path
 * @param {string} projectFullPath
 * @param {any} snippetId
 * @param {any} ref
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSnippetBlobRawPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSnippetBlobRawPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"snippet_id":{"r":true},"ref":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"snippet_id"],[2,[7,"/"],[2,[6,"raw"],[2,[7,"/"],[2,[3,"ref"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSnippetBlobRawPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"snippet_id":{"r":true},"ref":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"snippet_id"],[2,[7,"/"],[2,[6,"raw"],[2,[7,"/"],[2,[3,"ref"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSnippetBlobRawPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSnippetBlobRawPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/import/jira(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectImportJiraPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectImportJiraPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"jira"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectImportJiraPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"jira"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectImportJiraPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectImportJiraPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets/:id/raw(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rawProjectSnippetPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _rawOrganizationNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"raw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _rawNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"raw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _rawOrganizationNamespaceProjectSnippetPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _rawNamespaceProjectSnippetPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets/:id/mark_as_spam(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsSpamProjectSnippetPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _markAsSpamOrganizationNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_spam"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _markAsSpamNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_spam"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _markAsSpamOrganizationNamespaceProjectSnippetPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _markAsSpamNamespaceProjectSnippetPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSnippetsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSnippetsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectSnippetsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSnippetsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSnippetsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectSnippetPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectSnippetPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectSnippetPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectSnippetPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectSnippetPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectSnippetPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/snippets/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSnippetPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSnippetPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSnippetPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectFeatureFlagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectFeatureFlagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/:iid/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectFeatureFlagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectFeatureFlagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/:iid(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags_client/reset_token(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetTokenProjectFeatureFlagsClientPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resetTokenOrganizationNamespaceProjectFeatureFlagsClientPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_client"],[2,[7,"/"],[2,[6,"reset_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _resetTokenNamespaceProjectFeatureFlagsClientPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_client"],[2,[7,"/"],[2,[6,"reset_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resetTokenOrganizationNamespaceProjectFeatureFlagsClientPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resetTokenNamespaceProjectFeatureFlagsClientPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags_user_lists(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagsUserListsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagsUserListsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagsUserListsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagsUserListsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagsUserListsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags_user_lists/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectFeatureFlagsUserListPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectFeatureFlagsUserListPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectFeatureFlagsUserListPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectFeatureFlagsUserListPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectFeatureFlagsUserListPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags_user_lists/:iid/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectFeatureFlagsUserListPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectFeatureFlagsUserListPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectFeatureFlagsUserListPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectFeatureFlagsUserListPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectFeatureFlagsUserListPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags_user_lists/:iid(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagsUserListPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagsUserListPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagsUserListPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags_user_lists"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagsUserListPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagsUserListPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/schema/:branch/*filename
 * @param {string} projectFullPath
 * @param {any} branch
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSchemaPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSchemaPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"branch":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"schema"],[2,[7,"/"],[2,[3,"branch"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSchemaPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"branch":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"schema"],[2,[7,"/"],[2,[3,"branch"],[2,[7,"/"],[5,[3,"filename"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSchemaPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSchemaPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/hooks/:id/test(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testProjectHookPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _testOrganizationNamespaceProjectHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _testNamespaceProjectHookPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _testOrganizationNamespaceProjectHookPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _testNamespaceProjectHookPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/hooks/:hook_id/hook_logs/:id/retry(.:format)
 * @param {string} projectFullPath
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryProjectHookHookLogPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _retryOrganizationNamespaceProjectHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _retryNamespaceProjectHookHookLogPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationNamespaceProjectHookHookLogPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _retryNamespaceProjectHookHookLogPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/hooks/:hook_id/hook_logs/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} hookId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHookHookLogPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHookHookLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectHookHookLogPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"hook_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"hook_id"],[2,[7,"/"],[2,[6,"hook_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHookHookLogPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHookHookLogPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/hooks(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHooksPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHooksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectHooksPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHooksPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHooksPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/hooks/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectHookPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectHookPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectHookPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectHookPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/hooks/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHookPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHookPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectHookPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHookPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHookPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/integrations/slash_commands/confirm(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmProjectIntegrationsSlashCommandsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _confirmOrganizationNamespaceProjectIntegrationsSlashCommandsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slash_commands"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _confirmNamespaceProjectIntegrationsSlashCommandsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slash_commands"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _confirmOrganizationNamespaceProjectIntegrationsSlashCommandsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _confirmNamespaceProjectIntegrationsSlashCommandsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/integrations/slash_commands(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIntegrationsSlashCommandsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsSlashCommandsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slash_commands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsSlashCommandsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slash_commands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIntegrationsSlashCommandsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIntegrationsSlashCommandsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/badges/custom(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customProjectBadgesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _customOrganizationNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[6,"custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _customNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[6,"custom"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _customOrganizationNamespaceProjectBadgesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _customNamespaceProjectBadgesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/badges/release(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseProjectBadgesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _releaseOrganizationNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[6,"release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _releaseNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[6,"release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _releaseOrganizationNamespaceProjectBadgesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _releaseNamespaceProjectBadgesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/harbor/repositories/:repository_id/artifacts/:artifact_id/tags(.:format)
 * @param {string} projectFullPath
 * @param {any} repositoryId
 * @param {any} artifactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHarborRepositoryArtifactTagsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHarborRepositoryArtifactTagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true},"artifact_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"artifact_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectHarborRepositoryArtifactTagsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true},"artifact_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"artifact_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHarborRepositoryArtifactTagsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHarborRepositoryArtifactTagsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/harbor/repositories/:repository_id/artifacts(.:format)
 * @param {string} projectFullPath
 * @param {any} repositoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHarborRepositoryArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHarborRepositoryArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectHarborRepositoryArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHarborRepositoryArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHarborRepositoryArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/harbor/repositories(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHarborRepositoriesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHarborRepositoriesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectHarborRepositoriesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHarborRepositoriesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHarborRepositoriesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/harbor/repositories/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectHarborRepositoryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectHarborRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectHarborRepositoryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectHarborRepositoryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectHarborRepositoryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/experiments(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlExperimentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlExperimentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"experiments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlExperimentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"experiments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlExperimentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlExperimentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/experiments/:iid(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlExperimentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlExperimentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"experiments"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlExperimentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"experiments"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlExperimentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlExperimentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/candidates/:iid/promote(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promoteProjectMlCandidatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _promoteOrganizationNamespaceProjectMlCandidatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"candidates"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _promoteNamespaceProjectMlCandidatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"candidates"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _promoteOrganizationNamespaceProjectMlCandidatePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _promoteNamespaceProjectMlCandidatePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/candidates/:iid(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlCandidatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlCandidatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"candidates"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlCandidatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"candidates"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlCandidatePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlCandidatePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models/:model_model_id/versions/new(.:format)
 * @param {string} projectFullPath
 * @param {any} modelModelId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectMlModelVersionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectMlModelVersionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"model_model_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_model_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectMlModelVersionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"model_model_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_model_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectMlModelVersionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectMlModelVersionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models/:model_model_id/versions/:model_version_id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} modelModelId
 * @param {any} modelVersionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectMlModelVersionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectMlModelVersionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"model_model_id":{"r":true},"model_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_model_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"model_version_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectMlModelVersionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"model_model_id":{"r":true},"model_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_model_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"model_version_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectMlModelVersionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectMlModelVersionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models/:model_model_id/versions/:model_version_id(.:format)
 * @param {string} projectFullPath
 * @param {any} modelModelId
 * @param {any} modelVersionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlModelVersionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlModelVersionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"model_model_id":{"r":true},"model_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_model_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"model_version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlModelVersionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"model_model_id":{"r":true},"model_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_model_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"model_version_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlModelVersionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlModelVersionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlModelsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlModelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlModelsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlModelsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlModelsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectMlModelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectMlModelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectMlModelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectMlModelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectMlModelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models/:model_id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} modelId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectMlModelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectMlModelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"model_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectMlModelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"model_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectMlModelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectMlModelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/models/:model_id(.:format)
 * @param {string} projectFullPath
 * @param {any} modelId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlModelPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlModelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"model_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlModelPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"model_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"models"],[2,[7,"/"],[2,[3,"model_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlModelPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlModelPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/ml/preview_markdown(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMlPreviewMarkdownPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMlPreviewMarkdownPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMlPreviewMarkdownPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ml"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMlPreviewMarkdownPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMlPreviewMarkdownPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/service_desk/custom_email(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectServiceDeskCustomEmailPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectServiceDeskCustomEmailPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"service_desk"],[2,[7,"/"],[2,[6,"custom_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectServiceDeskCustomEmailPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"service_desk"],[2,[7,"/"],[2,[6,"custom_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectServiceDeskCustomEmailPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectServiceDeskCustomEmailPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/:noteable_type/:noteable_id/discussions/:id/resolve(.:format)
 * @param {string} projectFullPath
 * @param {any} noteableType
 * @param {any} noteableId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveProjectDiscussionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resolveOrganizationNamespaceProjectDiscussionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"noteable_type":{"r":true},"noteable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[3,"noteable_type"],[2,[7,"/"],[2,[3,"noteable_id"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _resolveNamespaceProjectDiscussionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"noteable_type":{"r":true},"noteable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[3,"noteable_type"],[2,[7,"/"],[2,[3,"noteable_id"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resolveOrganizationNamespaceProjectDiscussionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resolveNamespaceProjectDiscussionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/:noteable_type/:noteable_id/discussions/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} noteableType
 * @param {any} noteableId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDiscussionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDiscussionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"noteable_type":{"r":true},"noteable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[3,"noteable_type"],[2,[7,"/"],[2,[3,"noteable_id"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectDiscussionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"noteable_type":{"r":true},"noteable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[3,"noteable_type"],[2,[7,"/"],[2,[3,"noteable_id"],[2,[7,"/"],[2,[6,"discussions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDiscussionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDiscussionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/attestations/:id/download(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadProjectAttestationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadOrganizationNamespaceProjectAttestationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"attestations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _downloadNamespaceProjectAttestationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"attestations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _downloadOrganizationNamespaceProjectAttestationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _downloadNamespaceProjectAttestationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/attestations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAttestationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAttestationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"attestations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAttestationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"attestations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAttestationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAttestationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/attestations/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAttestationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAttestationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"attestations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAttestationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"attestations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAttestationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAttestationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/restore(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRestorePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRestorePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectRestorePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRestorePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRestorePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/service_desk(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectServiceDeskPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectServiceDeskPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"service_desk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectServiceDeskPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"service_desk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectServiceDeskPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectServiceDeskPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/templates/:template_type(.:format)
 * @param {string} projectFullPath
 * @param {any} templateType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTemplatesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"template_type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTemplatesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"template_type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTemplatesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTemplatesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/templates/:template_type/:key(.:format)
 * @param {string} projectFullPath
 * @param {any} templateType
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTemplatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTemplatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"template_type":{"r":true},"key":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_type"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTemplatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"template_type":{"r":true},"key":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_type"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTemplatePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTemplatePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/description_templates/names/:template_type(.:format)
 * @param {string} projectFullPath
 * @param {any} templateType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTemplateNamesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTemplateNamesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"template_type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"description_templates"],[2,[7,"/"],[2,[6,"names"],[2,[7,"/"],[2,[3,"template_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTemplateNamesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"template_type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"description_templates"],[2,[7,"/"],[2,[6,"names"],[2,[7,"/"],[2,[3,"template_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTemplateNamesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTemplateNamesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/regenerate_unique_domain(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerateUniqueDomainProjectPagesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _regenerateUniqueDomainOrganizationNamespaceProjectPagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"regenerate_unique_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _regenerateUniqueDomainNamespaceProjectPagesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"regenerate_unique_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _regenerateUniqueDomainOrganizationNamespaceProjectPagesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _regenerateUniqueDomainNamespaceProjectPagesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains/:id/verify(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyProjectPagesDomainPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _verifyOrganizationNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _verifyNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _verifyOrganizationNamespaceProjectPagesDomainPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _verifyNamespaceProjectPagesDomainPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains/:id/retry_auto_ssl(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryAutoSslProjectPagesDomainPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _retryAutoSslOrganizationNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_auto_ssl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _retryAutoSslNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_auto_ssl"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _retryAutoSslOrganizationNamespaceProjectPagesDomainPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _retryAutoSslNamespaceProjectPagesDomainPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains/:id/clean_certificate(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanCertificateProjectPagesDomainPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cleanCertificateOrganizationNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clean_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cleanCertificateNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clean_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _cleanCertificateOrganizationNamespaceProjectPagesDomainPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _cleanCertificateNamespaceProjectPagesDomainPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPagesDomainsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPagesDomainsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectPagesDomainsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPagesDomainsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPagesDomainsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectPagesDomainPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectPagesDomainPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectPagesDomainPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectPagesDomainPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectPagesDomainPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectPagesDomainPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/domains/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPagesDomainPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectPagesDomainPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPagesDomainPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPagesDomainPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectPagesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectPagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newNamespaceProjectPagesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectPagesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectPagesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/pages(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPagesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectPagesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPagesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPagesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/prometheus/alerts/notify(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifyProjectPrometheusAlertsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _notifyOrganizationNamespaceProjectPrometheusAlertsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"prometheus"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _notifyNamespaceProjectPrometheusAlertsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"prometheus"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _notifyOrganizationNamespaceProjectPrometheusAlertsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _notifyNamespaceProjectPrometheusAlertsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/alerts/notify(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAlertsNotifyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAlertsNotifyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAlertsNotifyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAlertsNotifyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAlertsNotifyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/alerts/notify/:name/:endpoint_identifier(.:format)
 * @param {string} projectFullPath
 * @param {any} name
 * @param {any} endpointIdentifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAlertHttpIntegrationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAlertHttpIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"name":{"r":true},"endpoint_identifier":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[3,"endpoint_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAlertHttpIntegrationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"name":{"r":true},"endpoint_identifier":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"notify"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[3,"endpoint_identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAlertHttpIntegrationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAlertHttpIntegrationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/container_registry(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectContainerRegistryIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectContainerRegistryIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"container_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectContainerRegistryIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"container_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectContainerRegistryIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectContainerRegistryIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/container_registry/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectContainerRegistryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectContainerRegistryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"container_registry"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectContainerRegistryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"container_registry"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectContainerRegistryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectContainerRegistryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/registry/repository/:repository_id/tags/bulk_destroy
 * @param {string} projectFullPath
 * @param {any} repositoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDestroyProjectRegistryRepositoryTagsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _bulkDestroyOrganizationNamespaceProjectRegistryRepositoryTagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"registry"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[6,"bulk_destroy"]]]]]]]]]]]]]]]]]]);
  const _bulkDestroyNamespaceProjectRegistryRepositoryTagsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"registry"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[6,"bulk_destroy"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _bulkDestroyOrganizationNamespaceProjectRegistryRepositoryTagsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _bulkDestroyNamespaceProjectRegistryRepositoryTagsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/registry/repository/:repository_id/tags
 * @param {string} projectFullPath
 * @param {any} repositoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRegistryRepositoryTagsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRegistryRepositoryTagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"registry"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[6,"tags"]]]]]]]]]]]]]]]]);
  const _namespaceProjectRegistryRepositoryTagsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"registry"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[6,"tags"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRegistryRepositoryTagsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRegistryRepositoryTagsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/registry/repository/:repository_id/tags/:id
 * @param {string} projectFullPath
 * @param {any} repositoryId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRegistryRepositoryTagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRegistryRepositoryTagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"registry"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectRegistryRepositoryTagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"repository_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"registry"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRegistryRepositoryTagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRegistryRepositoryTagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/notes/:id/resolve(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveProjectNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resolveOrganizationNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _resolveNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _resolveOrganizationNamespaceProjectNotePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _resolveNamespaceProjectNotePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/notes/:id/outdated_line_change(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outdatedLineChangeProjectNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _outdatedLineChangeOrganizationNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"outdated_line_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _outdatedLineChangeNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"outdated_line_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _outdatedLineChangeOrganizationNamespaceProjectNotePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _outdatedLineChangeNamespaceProjectNotePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/notes(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectNotesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNotesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectNotesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectNotesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectNotesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/notes/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectNotePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectNotePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/noteable/:target_type/:target_id/notes(.:format)
 * @param {string} projectFullPath
 * @param {any} targetType
 * @param {any} targetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectNoteableNotesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNoteableNotesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"noteable"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNoteableNotesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"target_type":{"r":true},"target_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"noteable"],[2,[7,"/"],[2,[3,"target_type"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectNoteableNotesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectNoteableNotesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/todos(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTodosPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTodosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectTodosPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTodosPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTodosPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/uploads/:secret/:filename
 * @param {string} projectFullPath
 * @param {any} secret
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showProjectUploadsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _showOrganizationNamespaceProjectUploadsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"secret":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"secret"],[2,[7,"/"],[3,"filename"]]]]]]]]]]]]]]);
  const _showNamespaceProjectUploadsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"secret":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"secret"],[2,[7,"/"],[3,"filename"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _showOrganizationNamespaceProjectUploadsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _showNamespaceProjectUploadsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/uploads/authorize(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizeProjectUploadsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _authorizeOrganizationNamespaceProjectUploadsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _authorizeNamespaceProjectUploadsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _authorizeOrganizationNamespaceProjectUploadsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _authorizeNamespaceProjectUploadsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/uploads(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectUploadsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectUploadsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectUploadsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectUploadsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectUploadsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/runner_projects(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRunnerProjectsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRunnerProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectRunnerProjectsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRunnerProjectsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRunnerProjectsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/runner_projects/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRunnerProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRunnerProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectRunnerProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"runner_projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRunnerProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRunnerProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/badges/*ref/pipeline(.:format)
 * @param {string} projectFullPath
 * @param {any} ref
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipelineProjectBadgesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _pipelineOrganizationNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"ref":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[5,[3,"ref"]],[2,[7,"/"],[2,[6,"pipeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _pipelineNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"ref":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[5,[3,"ref"]],[2,[7,"/"],[2,[6,"pipeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _pipelineOrganizationNamespaceProjectBadgesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _pipelineNamespaceProjectBadgesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/badges/*ref/coverage(.:format)
 * @param {string} projectFullPath
 * @param {any} ref
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coverageProjectBadgesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _coverageOrganizationNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"ref":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[5,[3,"ref"]],[2,[7,"/"],[2,[6,"coverage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _coverageNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"ref":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"badges"],[2,[7,"/"],[2,[5,[3,"ref"]],[2,[7,"/"],[2,[6,"coverage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _coverageOrganizationNamespaceProjectBadgesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _coverageNamespaceProjectBadgesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/badges(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectBadgesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"badges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectBadgesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"badges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectBadgesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectBadgesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/ide_terminals/:id/cancel(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelProjectWebIdeTerminalPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cancelOrganizationNamespaceProjectWebIdeTerminalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _cancelNamespaceProjectWebIdeTerminalPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _cancelOrganizationNamespaceProjectWebIdeTerminalPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _cancelNamespaceProjectWebIdeTerminalPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/ide_terminals/:id/retry(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryProjectWebIdeTerminalPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _retryOrganizationNamespaceProjectWebIdeTerminalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _retryNamespaceProjectWebIdeTerminalPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _retryOrganizationNamespaceProjectWebIdeTerminalPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _retryNamespaceProjectWebIdeTerminalPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/ide_terminals/check_config(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkConfigProjectWebIdeTerminalsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _checkConfigOrganizationNamespaceProjectWebIdeTerminalsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[6,"check_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _checkConfigNamespaceProjectWebIdeTerminalsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[6,"check_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _checkConfigOrganizationNamespaceProjectWebIdeTerminalsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _checkConfigNamespaceProjectWebIdeTerminalsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/ide_terminals(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectWebIdeTerminalsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectWebIdeTerminalsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectWebIdeTerminalsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectWebIdeTerminalsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectWebIdeTerminalsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/ide_terminals/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectWebIdeTerminalPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectWebIdeTerminalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectWebIdeTerminalPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"ide_terminals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectWebIdeTerminalPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectWebIdeTerminalPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/transfer(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _transferOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _transferNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _transferOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _transferNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/remove_fork(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeForkProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _removeForkOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_fork"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _removeForkNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_fork"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _removeForkOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _removeForkNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/archive(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archiveProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _archiveOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _archiveNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _archiveOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _archiveNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/unarchive(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unarchiveProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _unarchiveOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _unarchiveNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _unarchiveOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _unarchiveNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/housekeeping(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const housekeepingProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _housekeepingOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _housekeepingNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"housekeeping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _housekeepingOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _housekeepingNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/toggle_star(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStarProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleStarOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_star"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _toggleStarNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_star"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleStarOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleStarNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/export(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _exportOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _exportNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _exportOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _exportNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/remove_export(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeExportProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _removeExportOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _removeExportNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _removeExportOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _removeExportNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/generate_new_export(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateNewExportProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _generateNewExportOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_new_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _generateNewExportNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_new_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _generateNewExportOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _generateNewExportNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/download_export(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadExportProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _downloadExportOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _downloadExportNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _downloadExportOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _downloadExportNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/activity(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _activityOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _activityNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _activityOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _activityNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/refs(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refsProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _refsOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _refsNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _refsOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _refsNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/new_issuable_address(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newIssuableAddressProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newIssuableAddressOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_issuable_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newIssuableAddressNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_issuable_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newIssuableAddressOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newIssuableAddressNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/unfoldered_environment_names(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfolderedEnvironmentNamesProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _unfolderedEnvironmentNamesOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unfoldered_environment_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _unfolderedEnvironmentNamesNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unfoldered_environment_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _unfolderedEnvironmentNamesOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _unfolderedEnvironmentNamesNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/edit(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _editNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _namespaceProjectPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * (/-/jira)/*namespace_id/:project_id(.:format)
 * @param {any} namespaceId
 * @param {any} projectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jiraPath = /*#__PURE__*/ (...args) => {
  const _organizationJiraPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[1,[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[6,"jira"]]]]],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);
  const _jiraPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[6,"jira"]]]]],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationJiraPath(gon.current_organization.path, ...args);
  }

  return _jiraPath(...args);
};

